<template>
  <div>
    <div class="detaientopo">
      <span :class="index==2?'active':''" @click="achejr(2)">全部</span>
      <span :class="index==0?'active':''" @click="achejr(0)">获得</span>
      <span :class="index==1?'active':''" @click="achejr(1)">消耗</span>
      <div class="oyhkliuber"></div>
      <div :class="index==3?'active':''" @click="achejr(3)">
        <span>筛选时间 <img src="../../assets/image/icon_dropdown.png" alt=""></span>
      </div>
    </div>
    <div style="height: 1rem"></div>
    <md-date-picker
      ref="datePicker"
      v-model="isDatePickerShow"
      type="custom"
      title="筛选时间"
      large-radius
      :mask-closable="false"
      :text-render="textRender"
      :custom-types="['yyyy', 'MM',]"
      :default-date="currentDate"
      @confirm="onDatePickerConfirm"
    ></md-date-picker>
    <div v-if="list.length>0">
      <div class="jinitenr" v-for="(item,index) in list" :key="index">
        <div :class="index<list.length-1?'liuebhr':'liuebhr jerjjr'">
          <div class="kfkkkr">
          <img src="../../assets/image/bnjmwjm.png" alt="">
          <div style="display: flex;flex-direction: column;align-items: flex-start">
            <span style="font-size: 0.32rem;margin-bottom: 0.05rem">{{item.taskName}}</span>
            <span style="font-size:0.24rem;color: #999999;margin-top: 0.05rem ">{{item.gainYear}}年{{item.gainMonth}}月{{item.gainDay}}日</span>
          </div>
        </div>
        <span v-if="item.changeType==0" style="font-size: 0.4rem">+{{item.gainCredit}}</span>
        <span v-else style="font-size: 0.4rem;color: #F9311A">-{{item.gainCredit}}</span>
        </div>
      </div>
    </div>
    <div v-else style="width: 100%;height: 3rem;display: flex;justify-content: center;align-items: center;font-size: 0.4rem">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
import {DatePicker, Toast} from 'mand-mobile'

export default {
  name: "jinfedetaile",
  components: {
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      index: 2,
      gainMonth:null,
      gainYear:null,
      currentDate: new Date(),
      isDatePickerShow: false,
      list: []
    }
  },
  activated() {
    window.addEventListener("scroll",this.showbtn,true);
    Toast.loading('加载中...');
    this.getUserCreditDetail();
  },
  destroyed () {
    window.removeEventListener('scroll', this.showbtn,false);
  },
  methods: {
    getUserCreditDetail(){
      const par={
        changeType:this.index<2?this.index:null,
        gainMonth:this.gainMonth,
        gainYear:this.gainYear,
      }
      this.backtop();
      this.ajax.AJAx(this.ports.getUserCreditDetail, 'post',par).then(res => {
        console.log('res',res)
        this.list=res;
        Toast.hide();
        this.loading=false;
      }).catch(err => {
        Toast.hide();
        this.loading=false;
      })
    },
    textRender() {
      const args = Array.prototype.slice.call(arguments)
      const typeFormat = args[0] // 类型
      const column2Value = args[3] // 第3列选中值
      if (typeFormat === 'dd') {
        return `*${column2Value}日`
      }
    },
    showbtn(){
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop
    },
    backtop(){
      var timer = setInterval(function(){
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.isTop = true;
        if(osTop === 0){
          clearInterval(timer);
        }
      },30)
    },
    onDatePickerConfirm(columnsValue) {
      console.log(columnsValue)
      this.gainYear=columnsValue[0].value;
      this.gainMonth=columnsValue[1].value;
      this.getUserCreditDetail();
    },
    achejr(index) {
      this.index = parseInt(index);
      if(this.index ==2){
        this.gainYear=null;
        this.gainMonth=null;
      }
      parseInt(index) >= 3 ? this.isDatePickerShow = true : null
      this.getUserCreditDetail();
    }
  }
}
</script>

<style scoped lang="less">
.detaientopo {
  width: 100%;
  height: 1rem;
  background-color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.28rem;
  color: #999999;
  position: fixed;
  top: 0;
  .oyhkliuber {
    width: 0.02rem;
    height: 0.32rem;
    background: #F2F2F2;
  }

  img {
    width: 0.2rem;
    height: auto;
  }

  .active {
    color: #333333;
  }
}
.jintimne{
  width: 90%;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
  color: #333333;
  font-weight: 400;
  height: 1rem;
  padding-left: 5%;
}
.jinitenr{
  background-color: white;
  margin-top: 0.2rem;
  .liuebhr{
    width: 90%;
    margin-left: 5%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1.36rem;
    border-bottom:0.02rem solid #F2F2F2;
    .kfkkkr{
      display: flex;
      align-items: center;
      img{
        width: 0.56rem;
        height: auto;
        margin-right: 0.1rem;
      }
    }

  }
  .jerjjr{
    border: none;
  }
}
</style>
